import { startCase } from "lodash";
import { snakeToCamelCase } from "core/utils/snakeToCamelCase";
import { EciLcoStatus, InquiryCheckoutStatus } from "typings/globalGQLTypes";

export const mapCheckoutStatusToDisplayName = (name: InquiryCheckoutStatus) => {
  switch (name) {
    case InquiryCheckoutStatus.checked_out:
      return "Checked out";
    case InquiryCheckoutStatus.not_checked_out:
      return "Not checked out";
    case InquiryCheckoutStatus.past_checkout_time:
      return "Past checkout time";
    default:
      return "";
  }
};

export const mapEciLcoStatusToDisplayName = (status?: EciLcoStatus | null) => {
  switch (status) {
    case EciLcoStatus.approved_pending_payment:
      return "Pending Payment";
    default:
      return status ? startCase(snakeToCamelCase(status)) : "";
  }
};

export const mapChannelToPlatform = (channel?: string | null) => {
  return channel ? startCase(snakeToCamelCase(channel)) : "";
};
